module.exports = "error-404-page h1 {\n  color: #9012fe;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/system/core/404/styles/error-404-page.styles.scss
// module id = ./src/app/system/core/404/styles/error-404-page.styles.scss
// module chunks = main